import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material"
import { useMutation, useQueryClient } from "react-query";
import axiosClient from "../../../../lib/axios";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { enqueueSnackbar } from "notistack";
import { useMemo } from "react";
import { TConfigCopyNorteIds, TFormEnvioConfigCopyNorteIds } from "..";

export default function DialogCriacaoEditCopyNorte({
    open,
    defaultValue,
    dataDefault,
    handleClose
}: DialogCriacaoEditCopyNorteProps) {

    const queryClient = useQueryClient();

    const isEdit = useMemo(() => Boolean(defaultValue), [defaultValue])
    const valoresIniciais = useMemo(() => defaultValue ? defaultValue : null, [defaultValue])

    const methods = useForm<TInternFilter>({
        defaultValues: valoresIniciais ? { [valoresIniciais.chave]: valoresIniciais.valor } : {}
    });
    const { control, handleSubmit} = methods

    const { mutate: atualizarConfig, isLoading } = useMutation({
        mutationKey: 'atualizar-configuracoes-copy-norte',
        mutationFn: (inputs: TFormEnvioConfigWhatsApp) => axiosClient.post(`atualizar-configuracoes`, inputs),
        onError: (error) => {
            console.error(error)
            enqueueSnackbar('Erro ao atualizar configuração!', { variant: 'error' });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(["pesquisar-configuracoes-copy-norte"])
            handleClose()
            enqueueSnackbar('Atualização da configuração realizada com sucesso!', { variant: 'success' });
        }
    })
    //

    //Funções manipuladoras
    const onSubmit = (data: TInternFilter) => {

        const params: TFormEnvioConfigWhatsApp = {
            chave: 'copy_norte',
            valor: {
                ...dataDefault,
                ...data
            }
        }
        atualizarConfig(params)
    }

    return (
        <FormProvider {...methods}>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle >
                    {`${!isEdit ? "Adicionar" : "Editar"} integração`}
                </DialogTitle>
                    <>
                        <DialogContent>
                            <Grid container spacing={2} sx={{ paddingTop: 1 }}>
                                {
                                    isEdit &&
                                    <Grid size={{xs: 12}}>
                                        <Controller
                                            name={valoresIniciais?.chave || ""}
                                            rules={{ required: 'Campo obrigatório' }}
                                            control={control}
                                            render={({ field, fieldState: { error, invalid } }) => (
                                                <TextField
                                                    {...field}
                                                    required
                                                    error={invalid}
                                                    fullWidth
                                                    label={valoresIniciais?.chave ? valoresIniciais.chave.replace(/_/g, " ").replace(/\b\w/g, letra => letra.toUpperCase()) : ""}
                                                    value={field.value}
                                                    onChange={(valor) => {
                                                        field.onChange(valor.target.value);
                                                    }}
                                                    helperText={invalid ? error?.message : ""}
                                                />
                                            )}
                                        />
                                    </Grid>
                                }
                            </Grid>

                        </DialogContent>

                        <DialogActions>
                            <Button
                                onClick={handleClose}
                            >
                                Cancelar
                            </Button>
                            <Button
                                variant="contained"
                                autoFocus
                                disabled={isLoading}
                                onClick={handleSubmit(onSubmit)}
                            >
                                {
                                    (isLoading) &&
                                    <CircularProgress size={20} sx={{ marginRight: 1 }} />
                                }
                                {`${!isEdit ? "Adicionar" : "Editar"}`}
                            </Button>
                        </DialogActions>
                    </>
                
            </Dialog>
        </FormProvider>
    )
}

interface DialogCriacaoEditCopyNorteProps {
    open: boolean
    handleClose: VoidFunction
    defaultValue: TFormEnvioConfigCopyNorteIds | null
    dataDefault: TConfigCopyNorteIds
}

type TInternFilter = {
    [key: string]: string;
}

export type TFormEnvioConfigWhatsApp = {
    chave: string;
    valor: TConfigCopyNorteIds
}
